module.exports = __webpack_public_path__ + "img/KKR.6053e518.png";